import { render } from "./MobileOTPVerification.vue?vue&type=template&id=cad89728&scoped=true"
import script from "./MobileOTPVerification.vue?vue&type=script&lang=js"
export * from "./MobileOTPVerification.vue?vue&type=script&lang=js"

import "./MobileOTPVerification.vue?vue&type=style&index=0&id=cad89728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad89728"]])

export default __exports__